<template>
    <section class="hot-selling">
        <ul class="category">
            <li class="categort-item" v-for="item in goods" :key="item.id">
                <div
                    v-if="item.bannerPicture"
                    class="banner-image"
                    :style="{
                        background: `url(${handleImg({
                            url: item.bannerPicture.url,
                            height: 176
                        })}) 0 0 / 100% 100%`
                    }"
                ></div>
                <ul class="goods-list">
                    <li
                    class="global_pointer"
                        v-for="goodsItem in item.merchandises"
                        :key="goodsItem.id"
                        @click="navToGoodsDetail(goodsItem.id)"
                    >
                        <div class="goods-image">
                            <img
                                class="main"
                                v-lazy="
                                    handleImg({
                                        url: goodsItem.coverImgKey.url,
                                        width: 340,
                                        height: 340
                                    })
                                "
                                :key="
                                    handleImg({
                                        url: goodsItem.coverImgKey.url,
                                        width: 340,
                                        height: 340
                                    })
                                "
                                alt=""
                            />
                            <img
                                v-if="(goodsItem.videoKey || {}).url"
                                class="i-play"
                                src="https://fr-static.shopshops.top/20200328/icon_shop_Videodisplay@2x.f2ec7a4064268d52.png"
                                alt="播放按钮"
                            />
                        </div>
                        <div class="intro">
                            <h3>{{ goodsItem.name }}</h3>
                            <div class="price-warp-outer">
                                <div class="price-wrap">
                                    <div class="price">
                                        <span
                                            class="truth-price"
                                            v-if="!goodsItem.grouponActivityInfo"
                                        >
                                            {{
                                                `${goodsItem.miniAmountMoney.symbol}${priceSeparator(Number(goodsItem.miniAmountMoney.number).toFixed(2))}`
                                            }}
                                        </span>
                                        <!--活动价-->
                                        <span
                                            class="truth-price"
                                            v-if="goodsItem.grouponActivityInfo"
                                        >
                                            {{
                                                `${goodsItem.grouponActivityInfo.minActivityPriceMoney.symbol}${priceSeparator(Number(goodsItem.grouponActivityInfo.minActivityPriceMoney.number).toFixed(2))}`
                                            }}
                                        </span>
                                    </div>
                                    <span
                                        v-show="
                                                goodsItem.userDiscountStr  &&
                                                !goodsItem.canSecKill &&
                                                !goodsItem.canGroupon
                                        "
                                        class="userDiscount"
                                    >
                                        {{ goodsItem.userDiscountStr }}
                                    </span>
                                    <span class="activity" v-if="goodsItem.canSecKill">{{
                                        $t("message.store.seckill")
                                    }}</span>
                                    <span class="activity" v-if="goodsItem.canGroupon">{{
                                        $t("message.store.assembel")
                                    }}</span>
                                </div>
                                <!--正常价显示的原价-->
                                    <span v-if=" goodsItem.miniOrgAmountMoney " class="origin-price" >
                                        {{
                                            `${goodsItem.miniOrgAmountMoney.symbol}${priceSeparator(Number(goodsItem.miniOrgAmountMoney.number).toFixed(2))}`
                                        }}
                                    </span
                                >
                                <!--活动价显示的原价-->
                                <span
                                    v-if="
                                        goodsItem.grouponActivityInfo &&
                                            Number(
                                                (
                                                    goodsItem.grouponActivityInfo
                                                        .minActivityPriceMoney || {}
                                                ).number
                                            ) < Number((goodsItem.miniAmountMoney || {}).number)
                                    "
                                    class="origin-price"
                                    >{{
                                        `${goodsItem.miniAmountMoney.symbol}${priceSeparator(Number(goodsItem.miniAmountMoney.number).toFixed(2))}`
                                    }}</span
                                >
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
    </section>
</template>
<script>
import { priceSeparator } from '@/utils/formatUtil';
export default {
    props: {
        goods: Array
    },
    data() {
        return {
            priceSeparator
        }
    },
    methods: {
        navToGoodsDetail(id) {

            this.$router.push({
                    path: '/app/goods_detail',
                    query: {
                        goodsId: id,
                        source: 4
                    }
                })
        },
        formatDisCount(ud) {
            if (ud) {
                const disCount = Number(ud) * 10
                if (ud.toString().includes('.')) {
                    return disCount.toFixed(1)
                }
                return disCount
            }
            return NaN
        }
    }
}
</script>

<style lang="less" scoped>
img {
    display: block;
}
.category {
    padding: 12px 0;
    .banner-image {
        width: 100%;
        height: 88px;
    }
    .goods-list {
        display: flex;
        flex-wrap: wrap;
        padding: 0 12px;
        display: flex;
        justify-content: space-between;
        // &::after {
        //   content: '';
        // }
        li {
            width: 170px;
            // margin: 600px 550px 0 0;
            margin-top: 12px;
            background: #1D1D1D;
            border-radius: 4px;
            &:nth-of-type(2n) {
                margin-right: 0;
            }
        }
        .goods-image {
            position: relative;
            width: 170px;
            height: 170px;
            border-radius: 4px 4px 0 0;
            overflow: hidden;
            .main {
                width: 170px;
                height: 100%;
            }
            .i-play {
                position: absolute;
                bottom: 12px;
                left: 12px;
                width: 24px;
                height: 15px;
            }
        }
        .intro {
            padding: 12px;
            text-align: left;
            h3 {
                font-size: 14px;
                line-height: 20px;
                color: rgba(255,255,255,0.9);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .price-warp-outer {
                margin-top: 8px;
                display: flex;
                flex-direction: column;
                .price-wrap {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                     .userDiscount {
                         margin-left: 2.5px;
                        display: inline-block;
                        font-size: 10px;
                        color: #ffffff;
                        background: rgb(246, 99, 85);
                        padding: 1px 5px;
                        border-radius: 20px 20px 20px 0;
                        line-height: 16px;
                        height: 16px;
                    }
                    .discount,
                    .activity {
                        height: 18px;
                        /*margin-top: 200px;*/
                        padding: 0 3px;
                        font-size: 11px;
                        line-height: 18px;
                        color: #fff;
                        border-radius: 3px;
                        background-color: #b4282d;
                    }
                    .price {
                        display: flex;
                        flex-direction: column;
                        .truth-price {
                            font-size: 16px;
                            line-height: 16px;
                            color: #FC5B3F;
                        }
                    }
                }
                .origin-price {
                    margin-top: 4px;
                    font-size: 12px;
                    line-height: 17px;
                    color: #D8D8D8;
                    text-decoration: line-through;
                }
            }
        }
    }
}
</style>
